export const PARTY_ROLES_BY_GROUP = [
  {
    group: 'Cível',
    roles: [
      'Autor',
      'Réu',
      'Requerente',
      'Requerido',
      'Exequente',
      'Executado',
      'Litisconsorte Ativo',
      'Litisconsorte Passivo',
      'Terceiro Interessado',
      'Assistente Simples',
      'Denunciado à Lide',
      'Fiador / Avalista',
    ],
  },
  {
    group: 'Penal',
    roles: [
      'Investigado / Indiciado',
      'Réu / Acusado',
      'Querelante',
      'Querelado',
      'Vítima / Ofendido',
      'Assistente de Acusação',
      'Paciente (Habeas Corpus)',
    ],
  },
  {
    group: 'Trabalhista',
    roles: [
      'Reclamante',
      'Reclamada',
      'Responsável Solidário',
      'Responsável Subsidiário',
    ],
  },
  {
    group: 'Administrativo / Previdenciário',
    roles: [
      'Requerente (Admin / INSS)',
      'Impetrante',
      'Impetrado / Autoridade Coatora',
      'Interessado',
    ],
  },
  {
    group: 'Recursal',
    roles: [
      'Agravante',
      'Agravado',
      'Apelante',
      'Apelado',
      'Recorrente',
      'Recorrido',
      'Embargante',
      'Embargado',
    ],
  },
  {
    group: 'Societário / Família',
    roles: [
      'Sócio',
      'Administrador',
      'Representante Legal',
      'Inventariante',
      'Herdeiro',
      'Meeiro',
      'Cônjuge / Companheiro',
    ],
  },
  {
    group: 'Outros',
    roles: [
      'Terceiro',
      'Litisdenunciante',
      'Chamado ao Processo',
      'Interveniente',
    ],
  },
];

export const ALL_PARTY_ROLES = PARTY_ROLES_BY_GROUP.flatMap((g) => g.roles);
